import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/alert.svg'
import _imports_1 from '@/assets/check.svg'


const _hoisted_1 = { class: "flex items-center w-full flex-col text-white absolute bottom-0 footer" }
const _hoisted_2 = { class: "w-24 h-24 bg-white -mt-12 rounded-full flex justify-center items-center footer-icon z-20" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "w-16 h-16"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  class: "w-16"
}
const _hoisted_5 = { class: "h-full w-full flex flex-col justify-between p-10 pt-20 box-info" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex gap-5 justify-center" }
const _hoisted_8 = ["onclick"]
const _hoisted_9 = ["onclick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.participant.exists)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (_openBlock(), _createElementBlock("img", _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", {
        class: "text-center font-normal",
        innerHTML: _ctx.message
      }, null, 8, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn-primary bg-white text-blue-800 font-bold text-lg p-3 rounded-2xl custom-button w-full max-w-[50%]",
          onclick: _ctx.clearData
        }, " Fechar ", 8, _hoisted_8),
        (_ctx.participant.exists)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-primary bg-red-400 text-white font-bold text-lg p-3 rounded-2xl w-full custom-button",
              onclick: _ctx.removeParticipant
            }, " Remover ", 8, _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}